import * as React from 'react';
import { Dialog, DialogFooter, IDialogProps, Spinner, SpinnerSize } from '@fluentui/react';

export interface ILoadingResultDialogProps extends Omit<IDialogProps, 'children'> {
    isLoading: boolean;
    loadingLabel?: string;
    footer?: React.ReactNode;
}

const LoadingResultDialog: React.FunctionComponent<React.PropsWithChildren<ILoadingResultDialogProps>> = ({ isLoading, loadingLabel, footer, children, dialogContentProps, ...dialogProps }) => {
    return (
        <Dialog
            hidden={false}
            {...dialogProps}
            dialogContentProps={{ ...dialogContentProps, subText: isLoading ? undefined : dialogContentProps?.subText }}>
            {isLoading ? <Spinner size={SpinnerSize.large} label={loadingLabel} /> : children}
            {!isLoading && footer && <DialogFooter>{footer}</DialogFooter>}
        </Dialog>
    );
};

export default LoadingResultDialog;
